import React, { useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { Layout } from '../utility/Layout';

export default function POCAuthenticatedRoute({ component: Component, ...rest }) {
    const [registrationFeature, setRegistrationFeature] = useState(false);
    const [checked, setChecked] = useState(false);

    useEffect(() => {
        fetch('api/admin/GetFeatures')
            .then((response) => {
                response.json()
                    .then((json) => {
                        if (json.errors !== null && json.errors !== "") alert(json.errors)
                        for (var i = 0; i < json.message.length; i++) {
                            if (json.message[i].name === "registration") {
                                setRegistrationFeature(json.message[i].value);
                                setChecked(true)
                            }
                        }
                    })
                    .catch((error) => {
                        console.log("Retrieve json error: " + error);
                    })
            })
            .catch((error) => {
                console.log("Retrieve response error: " + error);
            })
    }, [])
    const isLoggedIn = () => {
        var userString = sessionStorage.getItem("user");
        if (userString === null || userString === "") {
            return false;
        }
        try {
            const user = JSON.parse(userString);
            if (user.isPOCUser === null) {
                return false;
            }
            if (user.memberID === null) {
                return false;
            }

            // any other checks

            // end other checks

            // it made it this far, should be auth
            return true;
        }
        catch (ex) {
            console.log("Trouble parsing user data: " + ex);
        }
    };
    return (
      <Route
      {...rest}
      render={
          () => {
              return checked ?
                  ((isLoggedIn() && registrationFeature)
                      ? <Layout role="poc"><Component /></Layout>
                      : <Redirect to='/logout' />
                  ):<></>
        }
      }
      />
    )
}